<template>
    <Modal modal-name="translation-modal" modal-class="translation-modal" :show-close-button="false">
        <div class="translation-modal__body">
            <div class="translation-modal__main">
                <div class="text-right">
                    <button class="translation-modal__close" @click="hideModal()">&times;</button>
                </div>
                <div class="translation-modal__title" v-html="$t('footerDictionary.translations.automaticTranslationWasUsed')"></div>
                <div class="d-flex justify-content-center">
                    <a
                        class="translation-modal__primary-button"
                        @click=";[keepOriginal(), hideModal()]"
                        v-html="$t('footerDictionary.translations.keepTheOriginalWording')"
                    ></a>
                    <a
                        class="translation-modal__primary-button"
                        @click="hideModal()"
                        v-html="$t('footerDictionary.translations.keepTranslation')"
                    ></a>
                </div>
            </div>
        </div>
    </Modal>
</template>

<script lang="ts" setup>
import { useNuxtApp } from '#app'
import { useI18n } from 'vue-i18n'
import Modal from '~/components/Modal.vue'

declare global {
    interface Window {
        google: any
    }
}

const config = useRuntimeConfig()
onMounted(() => {
    if (config.public.translateScript) {
        useNuxtApp().$bus.$on('translateWeb', (lang: string) => {
            doTranslate(lang)
        })

        useNuxtApp().$bus.$on('keepOriginalTranslation', () => {
            keepOriginal()
        })
    }
})

const hideModal = () => {
    setTimeout(() => {
        useNuxtApp().$bus.$emit('hideModal')
    })
}

const doTranslate = (lang: string) => {
    googleTranslateElementInit()

    const select: HTMLInputElement | null = document.querySelector('#google_translate_element select')
    if (select) {
        select.value = lang
        select.dispatchEvent(new Event('change'))

        setTimeout(() => {
            useNuxtApp().$bus.$emit('showModal', 'translation-modal')
        }, 200)
    }
}

const keepOriginal = () => {
    const iframe = document.getElementById(':1.container') as HTMLIFrameElement | null
    const restoreEl = iframe?.contentWindow?.document.getElementById(':1.restore')
    restoreEl?.click()
}

const handleGoogleBar = () => {
    document.addEventListener(
        'DOMNodeInserted',
        function (e) {
            const target = e.target as HTMLElement | null
            if (target?.classList?.contains('skiptranslate')) {
                target?.classList.add('d-none')
            }
        },
        true
    )
}

const i18n = useI18n()
const googleTranslateElementInit = () => {
    handleGoogleBar()

    const googleEl = document.createElement('div')
    googleEl.id = 'google_translate_element'
    googleEl.className = 'd-none'
    document.body.append(googleEl)

    window.google.translate.TranslateElement(
        {
            pageLanguage: i18n.t('footerDictionary.translations.pageLanguage'),
            includedLanguages: (i18n.tm('footerDictionary.translations.allowed') as string[]).toString(),
            autoDisplay: false,
        },
        googleEl.id
    )
}
</script>

<style lang="scss">
.translation-modal {
    &__body {
        display: flex;
        background: #fff4f2;
        border-radius: 10px;
    }

    .modal-content {
        padding: 0 !important;
        border-radius: 10px !important;
    }

    .modal-header {
        display: none !important;
    }

    &__main {
        padding: 10px 20px 15px 25px;
        background: rgba(255, 244, 242, 1);
        text-align: center;
    }

    &__title {
        margin-bottom: 15px;
        font-weight: 600;
        font-size: 20px;
    }

    &__primary-button {
        cursor: pointer;
        background: #e6007e;
        border: 1px solid #e6007e;
        border-radius: 100px;
        color: #fff;
        display: inline-block;
        font-size: 14px;
        font-weight: 500;
        padding: 8px 20px;
        text-align: center;
        margin: 10px;

        &:hover {
            background: #b80065;
            color: #fff;
        }
    }

    &__close {
        font-size: 0;
        width: 45px;
        height: 45px;
        position: relative;
        background-color: transparent;
        border: none;
        margin-right: -1rem;
        cursor: pointer;

        &::after {
            content: '';
            left: 0;
            top: 0;
            width: 45px;
            height: 45px;
            position: absolute;
            background: url('/nuxt-assets/icons/close.svg') no-repeat 50%;
        }
    }

    @media (max-width: 768px) {
        .modal-body {
            padding: 0 !important;
            height: auto !important;
        }

        &__main {
            padding: 5px 20px 20px 20px;
        }

        &__primary-button {
            margin-bottom: 20px;
        }
    }
}
</style>
